import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const isLocal = process.env.REACT_APP_ENVIRONMENT === 'local';
// const isDev = process.env.REACT_APP_ENVIRONMENT === 'dev';
// const isProd = process.env.REACT_APP_ENVIRONMENT === 'prod';

i18n
  .use(LanguageDetector)
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    debug: isLocal,
    fallbackLng: isLocal ? 'sv' : 'en',
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: '/golfclub-admin/locales/{{lng}}.json'
    },
    initImmediate: false
  });

export default i18n;
